<div [formGroup]="form" class="container">
  <h2>{{ "vehicle-info" | translate }}</h2>

  <div class="form-group">
    <label class="text-label">{{ "plate" | translate }}</label>
    <input
      type="text"
      class="style-input"
      placeholder="Introduce tu matrícula"
      formControlName="licensePlate"
      [class.invalid]="
        validationState.licensePlate && form.get('licensePlate')?.invalid
      "
    />
    <div
      class="error-message"
      *ngIf="validationState.licensePlate && form.get('licensePlate')?.invalid"
    >
      La matrícula es obligatoria.
    </div>
  </div>

  <div *ngIf="licensePlateNotFound" class="icon-and-help-text">
    <img
      class="iconssolidshield-exclamation"
      alt=""
      src="../assets/icons/shield-exclamation-red.svg"
    />
    <div class="lorem-ipsum-dolor-sit-amet-co-wrapper">
      <div class="lorem-ipsum-dolor">
        {{ "license-plate-not-found" | translate }}
      </div>
    </div>
  </div>

  <div *ngIf="licensePlateMandatory" class="icon-and-help-text">
    <img
      class="iconssolidshield-exclamation"
      alt=""
      src="../assets/icons/shield-exclamation-red.svg"
    />
    <div class="lorem-ipsum-dolor-sit-amet-co-wrapper">
      <div class="lorem-ipsum-dolor">
        {{ "this-field-is-required" | translate }}
      </div>
    </div>
  </div>

  <div *ngIf="!showManualForm" class="search-section">
    <button class="search-button" (click)="searchByLicensePlate()">
      <img
        class="search-button-icon"
        alt=""
        src="../assets/icons/search-icon.svg"
      />
      <label class="search-button-label">{{ "search" | translate }}</label>
    </button>
    <a class="manual-link" (click)="toggleManualForm()">{{
      "add-vehicle-manually" | translate
    }}</a>
  </div>

  <div *ngIf="!showManualForm">
    <div *ngIf="vehicleDataFromApi" class="tu-vehculo-parent">
      <div class="tu-vehculo">{{ "your-vehicle" | translate }}</div>
      <div class="productos-parent">
        <div class="productos">
          <img
            class="productos-icon"
            alt=""
            src="../assets/icons/green-car.svg"
          />
        </div>
        <div class="cupra-formentor-parent">
          <div class="cupra-formentor">
            {{ vehicleDataFromApi?.Brand | translate }}
            {{ vehicleDataFromApi?.Model | translate }}
          </div>
          <div class="kyt-gasolina">
            {{ vehicleDataFromApi?.LicensePlate | translate }} •
            {{ readableFuelType | translate }} •
            {{ readableVehicleType | translate }}
          </div>
        </div>
      </div>
      <button class="next-button" (click)="handleNext()">
        {{ "next" | translate }}
      </button>
    </div>
  </div>

  <div *ngIf="showManualForm" class="manual-form">
    <div class="form-header">
      <a class="manual-link" (click)="toggleManualForm()">{{
        "add-vehicle-by-license-plate" | translate
      }}</a>
    </div>

    <app-custom-dropdown
      label="vehicle-type"
      [options]="vehicleTypeOptions"
      displayProperty="label"
      (optionSelected)="onVehicleTypeSelected($event)"
      formControlName="vehicleType"
      [control]="form.get('vehicleType')"
      [showErrors]="validationState.vehicleType"
    ></app-custom-dropdown>

    <div class="form-group">
      <label class="text-label">{{ "brand" | translate }}</label>
      <input
        type="text"
        id="marca"
        class="style-input"
        placeholder="Introduce la marca"
        formControlName="brand"
        [class.invalid]="validationState.model && form.get('brand')?.invalid"
      />
      <div
        class="error-message"
        *ngIf="validationState.brand && form.get('brand')?.invalid"
      >
        La marca es obligatoria.
      </div>
    </div>

    <div class="form-group">
      <label class="text-label">{{ "model" | translate }}</label>
      <input
        type="text"
        id="modelo"
        class="style-input"
        placeholder="Introduce el modelo"
        formControlName="model"
        [class.invalid]="validationState.model && form.get('model')?.invalid"
      />
      <div
        class="error-message"
        *ngIf="validationState.model && form.get('model')?.invalid"
      >
        El modelo es obligatorio.
      </div>
    </div>

    <app-custom-dropdown
      label="fuel"
      [options]="fuelTypeOptions"
      displayProperty="label"
      formControlName="fuelType"
      (optionSelected)="onFuelTypeSelected($event)"
      [control]="form.get('fuelType')"
      [showErrors]="validationState.fuelType"
    ></app-custom-dropdown>
    <div class="al-continuar-tus-datos-sern-parent-2">
      <div class="al-continuar-tus">
        <span [innerHTML]="'first-information-layer' | translate"></span>
      </div>
    </div>
    <button class="next-button" (click)="handleNext()">
      {{ "next" | translate }}
    </button>
  </div>
</div>
<!-- <div *ngIf="!showManualForm" class="al-continuar-tus-datos-sern-parent">
  <div class="al-continuar-tus">
    <span [innerHTML]="'first-information-layer' | translate"></span>
  </div>
</div> -->
